<template>
  <b-form @submit.stop.prevent="validateWhenSubmit" novalidate="novalidate" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="form-group bmd-form-group">
          <label>
            <strong>Cliente:</strong>
            {{ proposal.client.name }}
          </label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Celular:</strong>
          </label>
          <label>{{ proposal.client.cell_phone | phone }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Residencial:</strong>
          </label>
          <label>{{ proposal.client.home_phone | phone }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Tel. Comercial:</strong>
          </label>
          <label>{{ proposal.client.commercial_phone | phone }}</label>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Bem:</strong>
          </label>
          <label
            v-if="proposal.model"
          >{{ proposal.model.manufacturer.name }} / {{ proposal.model.name }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Proposta:</strong>
          </label>
          <label>{{ proposal.id }} / {{ proposal.salesman.name }}</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group bmd-form-group">
          <label class="d-block">
            <strong>Informações da Parcela:</strong>
          </label>
          <label
            v-if="installment"
          >{{ installment.price | price }} - {{ installment.due_at | moment('DD/MM/YYYY') }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div
          class="form-group bmd-form-group"
          v-bind:class="{'is-filled': form.next_contact != '', 'has-danger': !!errors.first('next_contact') }"
        >
          <file-upload
            class="btn btn-primary text-lowercase"
            :multiple="false"
            :size="1024 * 1024 * 10"
            v-model="files"
            @input-file="inputFile"
            ref="upload"
            v-validate="formValidations.files"
            data-vv-name="files"
          >
            <template v-if="form.file">{{ form.file.name }}</template>
            <template v-else>
              <i class="fa fa-plus"></i>&nbsp;Selecione o boleto
            </template>
          </file-upload>

          <label
            v-if="!!errors.first('files')"
            class="error"
            for="files"
          >{{ errors.first('files') }}</label>
        </div>
      </div>
    </div>
    <hr />
    <b-button type="submit" variant="primary">Salvar</b-button>
  </b-form>
</template>

<script>
import { route as uploadRoute } from "@/services/modules/uploads.service.js";
export default {
  $_veeValidate: {
    validator: "new" // give me my own validator scope.
  },
  computed: {
    installment: {
      set(installment) {},
      get() {
        return this.$store.state.charges.item.data;
      }
    },
    proposal: {
      set(proposal) {},
      get() {
        return this.$store.state.proposals.item;
      }
    }
  },
  data() {
    return {
      uploadRoute: uploadRoute,
      formValidations: {
        files: {
          required: true,
          size: 5000,
          mimes: ["image/*", "application/msword", "application/pdf"]
        }
      },
      files: [],
      form: {
        file: null
      }
    };
  },
  created() {
    this.getProposal();
  },
  methods: {
    async inputFile(newFile, oldFile) {
      if (newFile) {
        this.form.file = {
          name: "",
          contentType: "",
          content: ""
        };
        this.$validator.validateAll();
        const data = await this.getBase64(newFile.file);
        this.form.file = {
          name: newFile.name,
          contentType: newFile.type,
          content: data
        };
      }
    },
    async getProposal() {
      this.$root.$emit("onLoading");

      const installment = await this.$store.dispatch(
        "charges/get",
        this.$route.params.id
      );

      const response = await this.$store.dispatch(
        "proposals/get",
        installment.data.proposal_id
      );

      this.$root.$emit("onLoading");

      this.form.proposal_id = installment.data.proposal_id;
      this.form.installment_id = installment.data.id;
    },
    validateWhenSubmit() {
      this.$validator.validateAll().then(isValid => {
        this.loading = false;
        if (isValid) {
          this.saveContact();
          return;
        }
      });
    },
    async saveContact() {
      this.$root.$emit("onLoading");

      const response = await this.$store.dispatch(
        "charges/sendSlips",
        this.form
      );

      this.$root.$emit("updateList");
      this.$root.$emit("hideModal");
      this.$notify.success(response.message);
      this.loading = false;
      this.$root.$emit("onLoading");
    }
  }
};
</script>

<style>
</style>
